import React, { createContext, useContext } from 'react';

import {
  DEFAULT_LAUNCHER_MX,
  DEFAULT_LAUNCHER_MY,
  DEFAULT_LAUNCHER_Z_INDEX,
  type LauncherEmbedStyle,
} from '@/lib/embed-style';

const defaultLauncherEmbedStyle: LauncherEmbedStyle = {
  mx: DEFAULT_LAUNCHER_MX,
  my: DEFAULT_LAUNCHER_MY,
  zIndex: DEFAULT_LAUNCHER_Z_INDEX,
};

const LauncherEmbedStyleContext = createContext<LauncherEmbedStyle>(defaultLauncherEmbedStyle);

interface LauncherEmbedStyleProviderProps {
  value: LauncherEmbedStyle;
  children: React.ReactNode;
}

export function LauncherEmbedStyleProvider({
  value,
  children,
}: LauncherEmbedStyleProviderProps) {
  return (
    <LauncherEmbedStyleContext.Provider value={value}>
      {children}
    </LauncherEmbedStyleContext.Provider>
  );
}

export function useLauncherEmbedStyle(): LauncherEmbedStyle {
  return useContext(LauncherEmbedStyleContext);
}
